import {
	BPanel,
	Button,
	Form,
	FormGroup,
	Col,
	ControlLabel,
	FormControl,
	Breadcrumb,
} from '@sketchpixy/rubix';
import { Router, Link, browserHistory, withRouter } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Reactive } from '../common/Reactive.mixin.js';

import { Meteor } from 'meteor/meteor';

import { Prices } from '../../collections/flights-type/prices';

@withRouter
@Reactive({
	subscriptions: ["flights-type"]
})
export default class PricesFormPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		if(this.props.params.id)
			this.price = Prices.find({_id: this.props.params.id}).fetch()[0];
		else
			this.price = {};
	}

	handleSubmit(e) {
		e.preventDefault();

		let params = {};
		let message = null;
		let method = null;

		params.attributes = {};
		_.each(this.refs, (ref, key) => {
			params.attributes[key] = ReactDOM.findDOMNode(ref).value.trim();   
		});


		if(this.props.params.id) {
			message = "Le tarif a été modifié avec succès.";
			method = "prices.update";
			params._id = this.props.params.id;
		}
		else {
			message = "Le tarif a été ajouté avec succès.";
			method = "prices.insert";
			params.attributes["createdAt"] = new Date();
		}

		Meteor.call(method, params, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: err,
					type: "error"
				});
				return; 
			}

			Messenger().post({
				message: message,
				type: "success"
			});

			this.props.router.push('/prices');
		}).bind(this));

	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/prices">Tarifs</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter/Modifier un Tarif
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Ajouter/Modifier un tarif">
					<Form horizontal onSubmit={this.handleSubmit.bind(this)}>
						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Titre du tarif
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="title" defaultValue={this.price.title} />
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Prix par passager
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="price" defaultValue={this.price.price}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Contrainte de période
							</Col>
							<Col sm={10}>
								<FormControl componentClass="select" placeholder="select" ref="constraintPeriod" defaultValue={this.price.constraintPeriod}>
									<option value="Aucune restriction">Aucune</option>
									<option value="Semaine uniquement">Semaine seulement</option>
								</FormControl>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Contrainte de lieu
							</Col>
							<Col sm={10}>
								<FormControl componentClass="select" placeholder="select" ref="constraintPlace" defaultValue={this.price.constraintPlace}>
									<option value="aucune">Aucune</option>
									<option value="anjou">Sites Anjou seulement</option>
									<option value="nantes">Sites Nantes seulement</option>
								</FormControl>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Contrainte d'age*
							</Col>
							<Col sm={2}>
								<FormControl type="text" ref="constraintAge" defaultValue={this.price.constraintAge}/>
							</Col>
							<Col sm={8}>
								<small>*Age maximum, laisser vide sinon</small>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Contrainte de poids*
							</Col>
							<Col sm={2}>
								<FormControl type="text" ref="constraintWeight" defaultValue={this.price.constraintWeight}/>
							</Col>
							<Col sm={8}>
								<small>*Poids maximum, laisser vide sinon</small>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Référence*
							</Col>
							<Col sm={2}>
								<FormControl type="text" ref="reference" defaultValue={this.price.reference}/>
							</Col>
							<Col sm={8}>
								<small>* laisser vide si ce prix n'existe pas sur le site.</small>
							</Col>
						</FormGroup>

						<FormGroup>
							<Col smOffset={2} sm={10}>
								<Button type="submit">
									Enregistrer
								</Button>
							</Col>
						</FormGroup>
					</Form>
				</BPanel>
			</div>
		);
	}
}

PricesFormPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/prices/PricesForm.page.js
 **/